var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumbergerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9193 10.0013C25.9193 9.31095 25.3596 8.7513 24.6693 8.7513H1.33594C0.645581 8.7513 0.0859375 9.31095 0.0859375 10.0013C0.0859375 10.6917 0.645581 11.2513 1.33594 11.2513H24.6693C25.3596 11.2513 25.9193 10.6917 25.9193 10.0013Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9193 1.66797C25.9193 0.977613 25.3596 0.417969 24.6693 0.417969H1.33594C0.645581 0.417969 0.0859375 0.977613 0.0859375 1.66797C0.0859375 2.35832 0.645581 2.91797 1.33594 2.91797H24.6693C25.3596 2.91797 25.9193 2.35832 25.9193 1.66797Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9193 18.3346C25.9193 17.6443 25.3596 17.0846 24.6693 17.0846H1.33594C0.645581 17.0846 0.0859375 17.6443 0.0859375 18.3346C0.0859375 19.025 0.645581 19.5846 1.33594 19.5846H24.6693C25.3596 19.5846 25.9193 19.025 25.9193 18.3346Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumbergerIcon);
export default __webpack_public_path__ + "static/media/HumbergerIcon.1659288e5e464cee9456e89c509788eb.svg";
export { ForwardRef as ReactComponent };